<template>
  <v-container fluid tag="section" class="pa-0">
    <v-card class="white mb-2 pa-3 rounded-lg elevation-0" :loading="loading">
        <v-row>
            <v-col cols="12" md='2'>
            <base-marerial-user-select  @on-change="loadData" label='提交人员' hide-details outlined dense v-model="form.uids"></base-marerial-user-select>
            </v-col>
            <v-col cols="12" md='2' class="mt-c-1">
            <v-btn color="primary" :loading="loading" class="px-2" @click="loadData"><v-icon>mdi-magnify</v-icon>查询</v-btn>
            </v-col>
        </v-row>
    </v-card>
    <div v-for="(data, idx) in userList" :key="idx" class="my-2">
      <v-card class="mx-auto elevation-0 py-3">
        <v-card-title class="py-1">{{data.name}}
          <v-spacer></v-spacer>
          <span class="ml-2">
            <v-btn  color='primary' @click="check(2, data, data.levelDic)" v-if="idx === showIdx">
                批量确认
            </v-btn>
            </span>
        </v-card-title>
        <v-list-item three-line>
          <v-list-item-avatar tile size="90" color="grey" class="rounded-lg">
            <v-img :src="data.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-row>
                <v-col cols="12" md='2' class="line-height-3">
                  签单数量：<span class="size-16 blue--text">{{data.signNumber}}</span>
                </v-col>
                <v-col cols="12" md='3' class="line-height-3">
                  签单总额：<span class="size-16 green--text">{{data.signPrice}}</span>
                </v-col>
                <v-col cols="12" md='3' class="line-height-3">
                  金额区间：<span class="size-16 orange--text">{{data.levelDic.code}}</span>
                </v-col>
                <v-col cols="12" md='2' class="line-height-3">
                  提成比例：<span class="size-16 red--text">{{data.levelDic.value}}%</span>
                </v-col>
                <v-col cols="12" md='2'>
                    <v-select
                    :items="userLevelItems"
                    label="人员级别"
                    hide-details='auto'
                    outlined
                    width="100"
                    item-text='name'
                    dense
                    item-value="id"
                    v-model="data.levelDic"
                    return-object
                    @change="levelChange($event, data)"
                    ></v-select>
                </v-col>
              </v-row>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions>
          <v-btn color="grey" small text @click="show(idx)">
            <v-icon>{{ idx === showIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showIdx ? '关闭回款' : '回款明细' }}
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
            <v-card v-if="idx === showIdx" elevation="0" class="pa-5">
                <v-row v-for="(i, index) in  data.commissionReturnsVos" :key="index" class="size-13">
                    <v-col cols="12" md='3'  class="line-height-2">
                        合同编号：<span>{{i.serialNumber}}</span>
                    </v-col>
                    <v-col cols="12" md='2'>
                        回款金额：<span class="green--text line-height-2">{{i.money}}</span>
                    </v-col>
                    <v-col cols="12" md='3'>
                        提成金额：<span class="blue--text line-height-2">{{i.ratioPrice}}</span>
                        <span class="red--text">&nbsp; -> {{ i.newRatioPrice }}</span>
                    </v-col>
                    <v-col cols="12" md='3' class="line-height-2">
                        回款时间：<span>{{i.returnTime | formatDay}}</span>
                    </v-col>
                    <v-col cols="12" md='1'>
                        <v-btn  color='orange' @click="check(1, i, data.levelDic)" dark small class="px-2" >确认</v-btn>
                    </v-col>
                </v-row>
            </v-card>
          </v-expand-transition>
      </v-card>
    </div>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { users, save } from '@/api/finance/commissionCheck.js'

  export default {
    name: 'CommissionCheck',
    components: {
    },
    data() {
      return {
        tab: 0,
        userList: [],
        form: { uids: [] },
        subForm: {},
        showIdx: -1,
        loading: false,
        userLevelItems: []
      }
    },
    methods: {
       show (idx) {
            this.showIdx = this.showIdx === idx ? -1 : idx
        },
        levelChange (obj, data) {
            data.commissionReturnsVos.forEach(i => {
                i.newRatioPrice = ((i.money - i.mediatorPrice - i.otherPrice) * obj.value / 100).toFixed(2)
            })
        },
        check (type, data, dic) {
            const form = type === 1 ? { type: 1, commissionReturn: data, levelDic: dic } : { type: 2, commissionCheck: data }
            console.log(form)
            this.$dialog.confirm({
            text: `确认${type === 1 ? '' : '批量'}核对提成金额吗?`,
            title: '系统提示',
            width: 300,
            actions: {
                false: { color: 'grey', text: '取消' },
                true: {
                    color: 'primary',
                    text: '确认',
                    handle: () => new Promise(resolve => {
                        save(form).then(response => {
                            if (response.status === 200) {
                                this.loadData()
                                this.$dialog.notify.success(`提交成功`, { position: 'top-right', timeout: 4000 })
                            }
                        resolve(response)
                        })
                    })
                }
            }
        })
      },
      loadData () {
        this.loading = true
        users(this.form).then(res => {
          if (res.status === 200) {
            this.userList = res.data
          }
          this.loading = false
        })
      },
      async getSelectItems () {
        await getByPids(
            {
            pids: [
              this.$constants.userLevelPid,
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.userLevelPid === result.id) {
                this_.userLevelItems = result.data.filter(i => i.value > 5)
              }
            })
          }
        })
      },
    },
    created () {
      this.loadData()
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
